// REDIRECTION FOR NON PREMIUM
import { css } from '@emotion/css';
import { Grid, MenuItem, Tab, Tabs } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LinkIcon from '@material-ui/icons/Link';
import {
  getBusinessAffiliate,
  getContractTypes,
  getOffresMap,
  setAffiliateAction,
} from '@webapps/business';
import {
  Pagination,
  PaginationNumbers,
  TextField,
  useAuth,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Affiliations from 'components/Icons/Affiliations';
import { useEffect, useState } from 'react';

import Accepted from './components/Accepted';
import Canceled from './components/Canceled';
import Candidats from './components/Candidats';

const BusinessAffiliation = () => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  // FRONT END RESTRICTIONS => Redirect to dashboard if free Account
  const { checkPermissions, isPremium } = useAuth();

  const [keyword, setKeyword] = useState('');
  const [offer, setOffer] = useState('');
  const [contractType, setContractType] = useState('');
  const [status, setStatus] = useState('');
  const [page, setPage] = useState(1);
  const [canceledCount, setCanceledCount] = useState(0);
  const [acceptedCount, setAcceptedCount] = useState(0);
  const { idUser } = useAuth();
  const [value, setValue] = useState(0);
  const [tabOrientation, setTabOrientation] = useState('horizontal');
  const [pendingCount, setPendingCount] = useState(0);

  const {
    // status: load,
    data: { content: candidatures = [], totalElements } = {},
    refetch: refetchCandidature,
    // isFetching,
  } = useQuery(getBusinessAffiliate, {
    key: [
      'cadidaturesAffiliateBusiness',
      page,
      keyword,
      offer,
      status,
      contractType,
    ],
    variables: {
      keyword,
      job: offer,
      contractType,
      status,
      id: idUser,
      page: page - 1,
      size: 1000,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const { data: { content: offres = [] } = {}, refetch } = useQuery(
    getOffresMap,
    {
      key: ['offres', page],
      variables: {
        businesses: idUser,
        page: page - 1,
        size: 1000,
        status: 'opened',
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: contractTypes = [] } = useQuery(getContractTypes, {
    key: 'contractTypes',
  });

  useEffect(() => {
    const updateOrientation = () => {
      const newOrientation =
        window.innerWidth < 768 ? 'vertical' : 'horizontal';
      setTabOrientation(newOrientation);
    };

    window.addEventListener('resize', updateOrientation);
    updateOrientation();

    return () => window.removeEventListener('resize', updateOrientation);
  }, []);

  useEffect(() => {
    const newWaitingCount = candidatures.filter(
      (item) =>
        item.status === 'CREATED' ||
        item.status === 'ACCEPTED' ||
        item.status === 'HALF-REJECTED'
    ).length;
    const newCanceledCount = candidatures.filter(
      (item) =>
        item.status === 'REJECTED' ||
        item.status === 'CANCELED' ||
        item.status === 'BROKEN'
    ).length;
    const newAcceptedCount = candidatures.filter(
      (item) => item.status === 'ENCLOSED'
    ).length;

    setCanceledCount(newCanceledCount);
    setAcceptedCount(newAcceptedCount);
  }, [candidatures]); // Dépendance sur les candidatures pour rafraîchir les compteurs

  useEffect(() => {
    if (isPremium !== null) {
      checkPermissions();
    }
  }, [isPremium]);

  if (!isPremium) {
    return <div></div>;
  }

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const searchKeyword = (e) => {
    setKeyword(e.target.value);
    setPage(1);
  };

  const searchOffer = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all' ? setOffer('') : setOffer(e.target.value);
      setPage(1);
    }
  };

  const searchContract = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all'
        ? setContractType('')
        : setContractType(e.target.value);
      setPage(1);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setKeyword('');
  };

  const handlePendingCount = (length) => {
    setPendingCount(length);
  };

  const handleAcceptedCount = (length) => {
    setAcceptedCount(length);
  };

  const handleCanceledCount = (length) => {
    setCanceledCount(length);
  };

  return (
    <div className={classes.container}>
      <Grid container style={{ height: '100%' }}>
        <Grid item xs style={{ height: '100%' }}>
          <Tabs
            value={value}
            indicatorColor="none"
            variant={window.innerWidth < 768 ? 'fullWidth' : 'standard'}
            TabIndicatorProps={{
              display: 'none',
            }}
            orientation={tabOrientation}
            onChange={handleChange}
          >
            <Tab
              label={`En attentes`}
              className={css({
                border: '1px solid #C0D9FF',
                borderBottom: 0,
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
                opacity: 1,
                backgroundColor: value === 0 ? 'white' : '#F3F7FF',
                color: value === 0 ? '#152652' : '#5A6DA1',
                fontWeight: value === 0 ? 600 : 400,
                minWidth: '10vw',
                fontFamily: 'Montserrat',
              })}
            />
            <Tab
              label={`Annulées`}
              className={css({
                border: '1px solid #C0D9FF',
                borderBottom: 0,
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
                opacity: 1,
                backgroundColor: value === 1 ? 'white' : '#F3F7FF',
                color: value === 1 ? '#152652' : '#5A6DA1',
                fontWeight: value === 1 ? 600 : 400,
                minWidth: '10vw',
                fontFamily: 'Montserrat',
              })}
            />
            <Tab
              label={`Acceptées`}
              className={css({
                border: '1px solid #C0D9FF',
                borderBottom: 0,
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
                opacity: 1,
                backgroundColor: value === 2 ? 'white' : '#F3F7FF',
                color: value === 2 ? '#152652' : '#5A6DA1',
                fontWeight: value === 2 ? 600 : 400,
                minWidth: '10vw',
                fontFamily: 'Montserrat',
              })}

            />
          </Tabs>
          <TabPanel value={value} index={0}>
            <Grid
              container
              direction="column"
              className={css({
                background: 'white',
                padding: '20px',
                borderRadius: '0px 10px 10px 10px',
                flexFlow: 'column',
                rowGap: 20,
                minHeight: !pendingCount && 'calc(100vh - 75px - 93px)',
                // maxHeight: 'calc(100vh - 75px - 93px)',
                '@media screen and (max-width: 1023px)': {
                  // maxHeight: '100%',
                },
                '@media screen and (max-width: 768px)': {
                  minHeight: !pendingCount && '100%',
                },
              })}
            >
              <div
                className={css({
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '10px',
                  '@media (max-width: 768px)': {
                    flexDirection: 'column',
                  },
                })}
              >
                <TextField
                  id="outlined-basic"
                  label="Prénom et nom"
                  onChange={(e) => searchKeyword(e)}
                  size="small"
                  variant="outlined"
                  borderRadius={30}
                />
                <div className={classes.selectInput}>
                  <TextField
                    fullWidth
                    label="Offre d'emploi en cours"
                    name="offer"
                    borderRadius={30}
                    onChange={(e) => searchOffer(e)}
                    variant="outlined"
                    select
                  >
                    <MenuItem value="all">Toutes les offres</MenuItem>
                    {offres.map(({ job }, index) => (
                      <MenuItem key={index} value={job?.ogr}>
                        {job?.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                <div className={classes.selectInput}>
                  <TextField
                    fullWidth
                    label="Type de contrat"
                    name="offer"
                    borderRadius={30}
                    onChange={(e) => searchContract(e)}
                    variant="outlined"
                    select
                  >
                    <MenuItem value="all">Tous les contrats</MenuItem>
                    {contractTypes.map(({ id, label }, index) => (
                      <MenuItem key={index} value={id}>
                        {label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              </div>

              <Grid container style={{ flex: 1 }}>
                <Candidats
                  candidatures={candidatures}
                  totalElements={totalElements}
                  contractTypes={contractTypes}
                  refetchCandidature={refetchCandidature}
                  offres={offres}
                  refetch={refetch}
                  handlePendingCount={handlePendingCount}
                />
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Grid
              container
              direction="column"
              className={css({
                background: 'white',
                rowGap: 20,
                minHeight: !canceledCount && 'calc(100vh - 75px - 93px)',
                // maxHeight: 'calc(100vh - 75px - 93px)',
                '@media screen and (max-width: 1023px)': {
                  // maxHeight: '100%',
                },
                '@media screen and (max-width: 768px)': {
                  minHeight: !canceledCount && '100%',
                },
                flexFlow: 'column',
                padding: '20px',
                borderRadius: '0px 10px 10px 10px',
                '@media screen and (max-width: 768px)': {
                  height: '100%',
                },
              })}
            >
              <div
                className={css({
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '10px',
                  '@media (max-width: 768px)': {
                    flexDirection: 'column',
                  },
                })}
              >
                <TextField
                  id="outlined-basic"
                  label="Prénom et nom"
                  onChange={(e) => searchKeyword(e)}
                  size="small"
                  variant="outlined"
                  borderRadius={30}
                />
                <div className={classes.selectInput}>
                  <TextField
                    fullWidth
                    label="Offre d'emploi en cours"
                    name="offer"
                    borderRadius={30}
                    onChange={(e) => searchOffer(e)}
                    variant="outlined"
                    select
                  >
                    <MenuItem value="all">Toutes les offres</MenuItem>
                    {offres.map(({ job }, index) => (
                      <MenuItem key={index} value={job?.ogr}>
                        {job?.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                <div className={classes.selectInput}>
                  <TextField
                    fullWidth
                    label="Type de contrat"
                    name="offer"
                    borderRadius={30}
                    onChange={(e) => searchContract(e)}
                    variant="outlined"
                    select
                  >
                    <MenuItem value="all">Tous les contrats</MenuItem>
                    {contractTypes.map(({ id, label }, index) => (
                      <MenuItem key={index} value={id}>
                        {label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              </div>

              <Grid container style={{ flex: 1 }}>
                <Canceled
                  candidatures={candidatures}
                  totalElements={totalElements}
                  contractTypes={contractTypes}
                  refetchCandidature={refetchCandidature}
                  offres={offres}
                  refetch={refetch}
                  handleCanceledCount={handleCanceledCount}
                />
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Grid
              container
              direction="column"
              className={css({
                minHeight: !acceptedCount && 'calc(100vh - 75px - 93px)',
                // maxHeight: 'calc(100vh - 75px - 93px)',
                '@media screen and (max-width: 1023px)': {
                  // maxHeight: '100%',
                },
                '@media screen and (max-width: 768px)': {
                  minHeight: !acceptedCount && '100%',
                },
                flexFlow: 'column',
                background: 'white',
                rowGap: 20,
                padding: '20px',
                borderRadius: '0px 10px 10px 10px',
                '@media screen and (max-width: 768px)': {
                  height: '100%',
                },
              })}
            >
              <div
                className={css({
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '10px',
                  '@media (max-width: 768px)': {
                    flexDirection: 'column',
                  },
                })}
              >
                <TextField
                  id="outlined-basic"
                  label="Prénom et nom"
                  onChange={(e) => searchKeyword(e)}
                  size="small"
                  variant="outlined"
                  borderRadius={30}
                />
                <div className={classes.selectInput}>
                  <TextField
                    fullWidth
                    label="Offre d'emploi en cours"
                    name="offer"
                    borderRadius={30}
                    onChange={(e) => searchOffer(e)}
                    variant="outlined"
                    select
                  >
                    <MenuItem value="all">Toutes les offres</MenuItem>
                    {offres.map(({ job }, index) => (
                      <MenuItem key={index} value={job?.ogr}>
                        {job?.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                <div className={classes.selectInput}>
                  <TextField
                    fullWidth
                    label="Type de contrat"
                    name="offer"
                    borderRadius={30}
                    onChange={(e) => searchContract(e)}
                    variant="outlined"
                    select
                  >
                    <MenuItem value="all">Tous les contrats</MenuItem>
                    {contractTypes.map(({ id, label }, index) => (
                      <MenuItem key={index} value={id}>
                        {label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              </div>

              <Grid container style={{ flex: 1 }}>
                <Accepted
                  candidatures={candidatures}
                  totalElements={totalElements}
                  contractTypes={contractTypes}
                  refetchCandidature={refetchCandidature}
                  offres={offres}
                  handleAcceptedCount={handleAcceptedCount}
                />
              </Grid>
            </Grid>
          </TabPanel>
        </Grid>
      </Grid>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    fontWeight: 400,
    color: '#5D75A8',
    lineHeight: '110%',
    '@media only screen and (max-width:768px)': { padding: '20px' },
  },
  paper: {
    '@media only screen and (max-width:768px)': { marginTop: spacing(5) },
  },
  selectInput: {
    width: '200px',
  }
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ padding: 0 }}
    >
      {value === index && (
        <Grid item style={{ height: '100%' }}>
          {children}
        </Grid>
      )}
    </div>
  );
}

export default BusinessAffiliation;
